import React from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useCustomerRevealApiKeyDelete } from 'features/customers/hooks/useCustomerRevealApiKeyDelete'

type DeleteApiKeyModalProps = {
  onClose: (...args: any[]) => any
}

const DeleteApiKeyModal = ({ onClose }: DeleteApiKeyModalProps) => {
  const { deleteRevealApiKey, isPending: isLoading } = useCustomerRevealApiKeyDelete()

  const onConfirm = async () => {
    deleteRevealApiKey()
    onClose()
  }

  return (
    <Dialog onClose={onClose} open>
      <DialogTitle>Delete Key</DialogTitle>
      <DialogContent style={{ width: 500 }}>
        <DialogContentText>
          Are you sure? This will remove all API access and limits for this customer.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button autoFocus color="primary" loading={isLoading} onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteApiKeyModal
